<h2 class="heading-with-paragraph sir-text-style-paragraph-l-bold" data-cy="header-section-1">
    {{ translations()!.applicationSpecificPalletizingPage.palletizingItemsTitle }}
</h2>
<p class="sir-text-style-paragraph-s-default" data-cy="paragraph-section-1">
    {{ translations()!.applicationSpecificPalletizingPage.palletizingItemsParagraph }}
</p>
<div class="options-container grid-column last-section">
    @for (option of questions().question1; track $index) {
        <matchmaking-form-option
            [option]="option"
            [isSelected]="optionIsSelected(option, selectedQuestions().question1)"
            (setSelected)="setQuestion1($event)"
            data-cy="question-1">
        </matchmaking-form-option>
    }
</div>

<h2 class="sir-text-style-paragraph-l-bold" data-cy="header-section-2">
    {{ translations()!.applicationSpecificPalletizingPage.palletizingItemWeightTitle }}
</h2>
<p class="sir-text-style-paragraph-s-default" data-cy="paragraph-section-2">
    {{ translations()!.applicationSpecificPalletizingPage.palletizingItemsParagraph }}
</p>
<div class="options-container row3 row last-section">
    @for (option of questions().question2; track $index) {
        <matchmaking-form-option
            [compact]="true"
            data-cy="question-2"
            [option]="option"
            [isSelected]="optionIsSelected(option, selectedQuestions().question2)"
            (setSelected)="setQuestion2($event)">
        </matchmaking-form-option>
    }
</div>

<h2 class="sir-text-style-paragraph-l-bold" data-cy="header-section-3">
    {{ translations()!.applicationSpecificPalletizingPage.palletizingProcessTitle }}
</h2>
<p class="sir-text-style-paragraph-s-default" data-cy="paragraph-section-3">
    {{ translations()!.applicationSpecificPalletizingPage.palletizingProcessParagraph }}
</p>
<div class="options-container row4 grid-column last-section">
    @for (option of questions().question3; track $index) {
        <matchmaking-form-option
            [compactIcon]="true"
            [option]="option"
            [isSelected]="optionIsSelected(option, selectedQuestions().question3)"
            (setSelected)="setQuestion3($event)"
            data-cy="question-3">
        </matchmaking-form-option>
    }
</div>

<h2 class="sir-text-style-paragraph-l-bold" data-cy="header-section-4">
    {{ translations()!.applicationSpecificPalletizingPage.palletizingSupportSetupTitle }}
</h2>
<p class="sir-text-style-paragraph-s-default" data-cy="paragraph-section-4">
    {{ translations()!.applicationSpecificPalletizingPage.palletizingSupportSetupParagraph }}
</p>
<div class="options-container grid-column last-section">
    @for (option of questions().question4; track $index) {
        <matchmaking-form-option
            [option]="option"
            [isSelected]="optionIsSelected(option, selectedQuestions().question4)"
            (setSelected)="setQuestion4($event)"
            data-cy="question-4">
        </matchmaking-form-option>
    }
</div>

<h2 class="sir-text-style-paragraph-l-bold" data-cy="header-section-5">
    {{ translations()!.applicationSpecificPalletizingPage.palletizingIntegrationSetupTitle }}
</h2>
<p class="sir-text-style-paragraph-s-default" data-cy="paragraph-section-5">
    {{ translations()!.applicationSpecificPalletizingPage.palletizingIntegrationSetupParagraph }}
</p>
<div class="options-container grid-column">
    @for (option of questions().question5; track $index) {
        <matchmaking-form-option
            [option]="option"
            [isSelected]="optionIsSelected(option, selectedQuestions().question5)"
            (setSelected)="setQuestion5($event)"
            data-cy="question-5">
        </matchmaking-form-option>
    }
</div>

<div>
    <matchmaking-form-textarea-input
        data-cy="form-textarea-input"
        [shouldFocus]="false"
        [answer]="selectedQuestions().question6"
        (updateQuestionAnswer)="setQuestion6($event)">
    </matchmaking-form-textarea-input>
</div>
